import { useState } from 'react';

const useMenuVisibility = () => {
  const [menuVisible, setMenuVisible] = useState(false);

  const toggleMenu = () => {
    setMenuVisible(!menuVisible);
  };

  return { menuVisible, toggleMenu };
};

export default useMenuVisibility;
